import {
    FC,
    FormEvent,
    FormEventHandler,
    PropsWithChildren,
    useMemo,
} from 'react';
import { Formik, FormikValues } from 'formik';
import { v4 as uuidV4 } from 'uuid';

export type FormProps<T extends FormikValues = any> = PropsWithChildren<{
    formik?: Formik<T>;
    onSubmit?: FormEventHandler<HTMLFormElement>;
    autoFocus?: boolean;
    prevent?: boolean;
    prohibitAutoComplete?: boolean;
}>;

export const Form: FC<FormProps> = (props: FormProps) => {
    const {
        formik,
        prohibitAutoComplete = true,
        onSubmit,
        children,
        autoFocus = false,
        prevent = true,
    } = props;

    const formSubmitHandler = useMemo(() => {
        if (onSubmit)
            return (event: FormEvent<HTMLFormElement>) => {
                if (prevent) event.preventDefault();
                return onSubmit(event);
            };

        if (formik) return formik.handleSubmit;

        return (event: FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            console.warn('Unhandled form', event);
        };
    }, [onSubmit, formik]);

    return (
        <form
            autoFocus={autoFocus}
            autoComplete={prohibitAutoComplete ? 'off' : 'on'}
            onSubmit={formSubmitHandler}
        >
            {children}

            {prohibitAutoComplete && (
                <input
                    name={uuidV4()}
                    type={'text'}
                    style={{ display: 'none' }}
                    autoComplete={'on'}
                />
            )}
        </form>
    );
};
